import React, { Component } from 'react';
import { observer, inject, mobx } from "mobx-react";
import { extendObservable, toJS, observable, entries } from "mobx";
/* css */
import '../../assets/css/iscrizione/iscrizione.css'
/* Component */
import ContactInformation from './ContactInformation.jsx'
import Captcha from './Captcha.jsx';
import TiTroviIn from '../widgets/titroviin.jsx'
import Wizard from '../widgets/addWizard.jsx'
import {listaStatiExtraUE, listaStatiNascitaIndir,listaIssuedBy,listaNascitaIndir,listaPlaceOfBusiness} from '../../config/constants'
/* react-web-components */
import { Input, Messages, DatePicker, SelectInput, Checkbox, Modal, RadioInput, Textarea } from '@sogei/react-web-components-catalog'
@inject("rootStore")
@observer



class Iscrizione extends Component {

    constructor (props) {
        super(props);

        this.infoStore = this.props.rootStore.infoStore
        
        
        this.onChangeCheck = this.onChangeCheck.bind(this)
        const checkboxList = [
            {
                id: "1",
                name: "1",
                value: "1",
                dimension: "sm",
                label: "Register for Non Union VAT OSS",
                inputClass: [],
                labelClass: ['ml-5'],
                event: { onChange: this.onChangeCheck },
                extraProps: { visible: true, checked: false }
            },
            {
                id: "2",
                name: "2",
                value: "2",
                dimension: "sm",
                label: "Register for Import OSS",
                inputClass: [],
                labelClass: ['ml-5'],
                event: { onChange: this.onChangeCheck },
                extraProps: { visible: true, checked: false }
            },
            {
                id: "3",
                name: "3",
                value: "3",
                dimension: "sm",
                label: "DAC 7 - Council Directive (EU) 2021/514",
                inputClass: [],
                labelClass: ['ml-5'],
                event: { onChange: this.onChangeCheck },
                extraProps: { visible: true, checked: false }
            }
        ]

        this.state = {
            value: '',
            checkboxList: checkboxList,
            listCheck: []
        }
        
    }


    componentWillUnmount () {
        this.infoStore.RedirectTo = undefined
        this.infoStore.review = false;
        this.infoStore.ErrorDate_ = false;
        this.infoStore.ErrorTelefono = false;
        this.infoStore.ErrorEmail = false;
        this.infoStore.ErrorEmail2 = false;
        this.infoStore.ErrorNome = false;
        this.infoStore.ErrorCognome = false;
        this.infoStore.ErrorWebsite = false;
        this.infoStore.ErrorCompany = false;
        this.infoStore.ErrorDescription = false;
        this.infoStore.ErrorAddress = false;
        this.infoStore.ErrorCity = false;
        this.infoStore.ErrorStato = false;
        this.infoStore.ErrorDate = false;
        this.infoStore.ErrorCountryBirth = false;
        this.infoStore.ErrorEmail3 = false;
        this.infoStore.ErrorEmail4 = false;
        this.infoStore.ErrorRelationship = false;
        this.infoStore.ErrorMessageInvia = false;
        this.infoStore.ErrorMessage = false;
    }
    onChangeCheck(event) {
    
        let listCheck = this.state.listCheck

        let find = listCheck.find(x=>x == event.target.name)
        if (find == undefined){
            listCheck.push(event.target.name)   
        }else{
            listCheck = listCheck.filter(x=> x != event.target.name)
        }

        const checkboxList = this.state.checkboxList.map((elem) => {
            if (elem.name === event.target.name)
                elem.extraProps.checked = event.target.checked
            return elem
        })

        console.log(listCheck)

        this.setState({ checkboxList: checkboxList, listCheck: listCheck})
    }

    submit = () => {
        this.infoStore.ErrorMessage = '';
        this.infoStore.controlFormOblContact();
        //this.infoStore.handleControlRadio()

        this.infoStore.handleControlCheck(this.state.listCheck)
        this.infoStore.listCheck  = this.state.listCheck

        if (this.infoStore.ErrorMessageText20 !== '' || this.infoStore.ErrorMessageText8 !== '') {
            this.infoStore.ErrorMessage = true;
            this.infoStore.ErrorMessage2 = true;
            if (this.infoStore.ErrorMessageText20 === '') {
                this.infoStore.ErrorMessage = false;
            }
            if (this.infoStore.ErrorMessageText8 === '') {
                this.infoStore.ErrorMessage2 = false;
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.infoStore.review = false;
        } else {
            this.infoStore.ErrorMessage = false;
            this.infoStore.ErrorMessage2 = false;
            this.infoStore.ErrorMessageText20 = ''
            this.infoStore.ErrorMessageText8 = ''
            this.infoStore.review = true;
            this.infoStore.conferma = true;
            this.infoStore.error = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    handleModifica = () => {
        this.infoStore.review = false;
        this.infoStore.conferma = false;
        this.infoStore.riepilogo = false;
        this.infoStore.ErrorMessage = false;
        this.infoStore.captchaLoaded = false
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    onChangeRadioInput = (e) => {
        const { name, value } = e.target;
        this.infoStore.RadioButton = value;
        console.log(this.infoStore.RadioButton)
    }


    Conferma = () => {
        this.infoStore.handleInvia()
    }

    CaptchaLabel () {
        var parent = document.querySelector('#CaptchaID');
        console.log(parent)
        if (parent) {
            if (parent.children[0]) {
                var labelAltraImmagine = parent.children[0].children[1].children[1].children[2].children[0] ? parent.children[0].children[1].children[1].children[2].children[0].className : null
                var labelSenti = parent.children[0].children[2].children[0].children[0] ? parent.children[0].children[2].children[0].children[0].className : null
                var labelVedi = parent.children[0].children[2].children[0] ? parent.children[0].children[2].children[0].className : null
                var AltImg = parent.children[0].children[1].children[0].children[0] ? parent.children[0].children[1].children[0].children[0].id : null
                console.log(labelAltraImmagine)
                if (labelAltraImmagine && labelSenti && labelVedi && AltImg) {
                    document.getElementsByClassName(labelAltraImmagine)[0].nextSibling.textContent = 'Another image';
                    document.getElementsByClassName(labelAltraImmagine)[1].nextSibling.textContent = 'Another audio';
                    console.log(labelSenti)
                    console.log(labelVedi)
                    document.getElementsByClassName(labelSenti)[0].textContent = 'or you hear';
                    document.getElementsByClassName(labelVedi)[0].textContent = 'Enter the characters you see:';
                    document.getElementById(AltImg).alt = "Security code"
                }
            }
        }
    }

    render () {
        const optionList = [{ optionValue: 'M', optionLabel: 'M' }, { optionValue: 'F', optionLabel: 'F' }]
       
        const { CheckButton, RadioButton, Information, review, Email, ErrorMessageText20, ErrorMessageText8, riepilogo, ErrorMessageText1, firstName, lastName, dateBirth, ErrorMessageText7, conferma, ErrorDate_,
            ErrorEmail, ErrorMessageText, ErrorMessageText2, ErrorMessageText3, ErrorCompany, ErrorMessageText14, error, ErrorMessage, ErrorMessage2, ErrorWebsite, ErrorMessageText9, ErrorMessageTextDate,
            ErrorEmail2, ErrorMessageText10, ErrorDescription, ErrorMessageText11, ErrorAddress, ErrorMessageText12, ErrorCity, ErrorMessageText13, ErrorStato, ErrorMessageTextInvia, ErrorMessageInvia } = this.infoStore;

        const extraProps = { disabled: review }

        const extraProps12 = {
            disabled: review,
            maxLength: '12'
        }
        const extraProps20 = {
            disabled: review,
            maxLength: '20'
        }
        const radioList3 = [{
            id: '1',
            label: 'Register for Non Union VAT OSS',
            radioValue: '1',
            extraProps: { disabled: review }
        },
        {
            id: '2',
            label: 'Register for Import OSS',
            radioValue: '2',
            extraProps: { disabled: review }
        },
        {
            id: '3',
            label: 'Both',
            radioValue: '3',
            extraProps: { disabled: review }
        }]
        const to = [
            {
                to: `${ process.env.CONTEXT_PATH }/home`,
                label: 'Home'
            }
        ]
        return (
            <section className="section py-2 py-md-3">
                {this.infoStore.RedirectTo ? this.infoStore.getRedirect() : ""}

                <div className="container-fluid py-3 py-md-4 backColor">
                    <TiTroviIn children={to} title={'Request'} index={2} ></TiTroviIn>
                    <div className="row">
                        <div className="col font-weight-bold mt-3 mb-3">
                            <span className="d-flex">
                                <h3> <strong className="fas fa-title fa-pencil-alt mr-2"></strong>Request for ID</h3>
                            </span>
                        </div>
                    </div>
                    {conferma ? <Wizard index={2} /> : <Wizard index={1} />}
                    {/*           <div className="row">
                        <div className="col-6">
                            <hr className="borderTitle"></hr>
                        </div>
                    </div> */}


                    {ErrorMessage2 ? <div className="col-6">
                        <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText8 }]}> </Messages>
                    </div> : ''}

                    {ErrorMessage ? <div className="col-6">
                        <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText20 }]}> </Messages>
                    </div> : ''}
                    {/*
                                        <div className="row mt-5 mb-4 ml-5 d-flex ">
                        <span className="font-weight-bold title mt-1 ml-5">Request for</span>
                        <div className="col fieldsetNone radioButton mt-0 mb-0 ml-5">
                            <RadioInput name='RadioButton' value={RadioButton} inline={false} legend=''
                                radioList={radioList3} inputClass={['fieldsetNone']} error={error}
                                labelClass={['fieldsetNone', 'ml-5']} event={{ onChange: this.onChangeRadioInput }} />
                        </div>
                    </div>
                    */}

                    <div className="row mt-5 mb-4 ml-5 d-flex ">
                        <span className="font-weight-bold title mt-1 ml-5">Request for</span>
                        <div className="col fieldsetNone radioButton mt-0 mb-0 ml-5">
                            <Checkbox 
                                checkboxList={this.state.checkboxList}
                                error={error}
                            ></Checkbox>
                        </div>
                    </div>

                    
                    <div className="row mb-2 justify-content-center align-items-center">
                        <span><em>Register for Import OSS is only available if you are established in a third country with which the EU has concluded an agreement on mutual assistance.</em></span>
                    </div>

                    {conferma ? <div className="row ml-1 mb-4">
                        <span className="font-weight-bold">Check the entered data and then press "Confirm" to transmit the data</span>
                    </div> : ''}

                    <fieldset id='contentFildset'>
                        <legend className="contentlegend">Business information</legend>

                        <div className="row">
                            <div className="col-5">
                                <div className="d-flex">
                                    <div className="col">
                                        <Input id='Denominazione' event={{ onChange: this.handleChange }} name='denominazione' type='text' dimension='lg' error={error}
                                            label='Company Name' value={this.infoStore.denominazione} inputClass={[]} labelClass={['requiredLabel']} extraProps={{ disabled: review, maxLength: 150 }} />
                                    </div>
                                </div>
                                {ErrorCompany ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText10 }]}> </Messages>
                                </div> : ''}
                            </div>
                            <div className="col d-flex align-items-center">
                                <em><span style={{ "font-size": "14px" }}>max 150 characters</span></em>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-5">
                                <div className="d-flex">
                                    <div className="col">
                                        <Input event={{ onChange: this.handleChange }} id='Sigla' name='sigla' type='text' dimension='lg'
                                            label='Trading name, if different from your Company Name' value={this.infoStore.sigla} inputClass={['mr-5']} labelClass={[]} extraProps={{ disabled: review, maxLength: 150 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col d-flex align-items-center">
                                <em><span style={{ "font-size": "14px" }}>max 150 characters</span></em>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-5">
                                <div className="d-flex">
                                    <div className="col-12">
                                        <Textarea event={{ onChange: this.handleChange }} id='descrizione' name='descrizione' type='text' dimension='lg' error={error}
                                            label='Business description' value={this.infoStore.descrizione} inputClass={['mr-5']} labelClass={['requiredLabel']} extraProps={{ disabled: review, maxLength: 200 }} />
                                    </div>
                                </div>
                                {ErrorDescription ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText11 }]}> </Messages>
                                </div> : ''}
                            </div>
                            <div className="col-2 d-flex align-items-center">
                                <em><span style={{ "font-size": "14px" }}>max 200 characters</span></em>
                            </div>
                            <div className="col-5" />
                        </div>

                        <div className="row">
                            <div className="col-6">
                            <div className="d-flex">
                                <div className="col-12">
                                    <span className="font-weight-bold">Please provide your National tax reference number and your Vat number, if available.</span>                            
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="row mt-1">
                            <div className="col-3 ml-3">
                                <Input event={{ onChange: this.handleChange }} id='CF' name='CF' type='text' dimension='lg'  error={error}
                                    label=' National tax reference number' value={this.infoStore.CF} inputClass={['mr-5']} labelClass={['requiredLabel']} extraProps={extraProps20} />
                            </div>
                            <div className="col-2 ml-5">
                                <SelectInput id='stato' name='stato' value={this.infoStore.stato} dimension='lg' label='Issuing Country' firstEmptyOption={true} optionList={listaIssuedBy}
                                    inputClass={[]} error={error} labelClass={['requiredLabel']} event={{ onChange: this.handleChange }} extraProps={extraProps} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3 ml-3">
                                <Input event={{ onChange: this.handleChange }} id='vat' name='vat' type='text' dimension='lg'
                                    label='VAT number' value={this.infoStore.vat} inputClass={['mr-5']} labelClass={[]} extraProps={extraProps12} />
                            </div>
                            <div className="col-2 ml-5">
                                <SelectInput id='issuedCountry' name='issuedCountry' value={this.infoStore.issuedCountry} dimension='lg' label='Issuing Country' firstEmptyOption={true} optionList={listaIssuedBy}
                                    inputClass={[]} labelClass={[]} event={{ onChange: this.handleChange }} extraProps={extraProps} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-5">
                                 <div className="d-flex">
                                     <div className="col-12">
                                        <Input event={{ onChange: this.handleChange }} id='sitoWeb' name='sitoWeb' type='text' dimension='lg' error={error}
                                            label='Website URL' value={this.infoStore.sitoWeb} inputClass={['mr-5']} labelClass={['requiredLabel']} extraProps={extraProps} />
                                    </div>
                                </div>
                                {ErrorWebsite ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText7 }]}> </Messages>
                                </div> : ''}
                            </div>
                            <div className="col-5" />
                        </div>

                        <div className="row">
                            <div className="col-4">
                                <div className="d-flex">
                                    <div className="col">
                                        <Input event={{ onChange: this.handleChange }} id='Email' name='Email' type='text' dimension='lg' error={error}
                                            label='E-mail' value={this.infoStore.Email} inputClass={[]} labelClass={['requiredLabel']} extraProps={extraProps} />
                                    </div>
                                </div>
                                {ErrorEmail ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText1 }]}> </Messages>
                                </div> : ''}
                            </div>
                            <div className="col-4 ml-2">
                                <div className="d-flex">
                                    <div className="col">
                                        <Input event={{ onChange: this.handleChange }} id='confermaEmail' name='confermaEmail' type='text' dimension='lg' error={error}
                                            label='Confirm E-mail' value={this.infoStore.confermaEmail} inputClass={[]} labelClass={['requiredLabel']} extraProps={extraProps} />
                                    </div>
                                </div>
                                {ErrorEmail2 ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText9 }]}> </Messages>
                                </div> : ''}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-5">
                                <div className="d-flex">
                                    <div className="col">
                                        <Input event={{ onChange: this.handleChange }} id='sede' name='sede' type='text' dimension='lg' error={error}
                                            label='Address' value={this.infoStore.sede} inputClass={['mr-5']} labelClass={['requiredLabel']} extraProps={extraProps} />
                                    </div>
                                </div>
                                {ErrorAddress ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText12 }]}> </Messages>
                                </div> : ''}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-3">
                                <div className="d-flex">
                                    <div className="col">
                                        <Input event={{ onChange: this.handleChange }} id='citta' name='citta' type='text' dimension='lg' error={error}
                                            label='City' value={this.infoStore.citta} inputClass={['mr-5']} labelClass={['requiredLabel']} extraProps={extraProps} />
                                    </div>
                                </div>
                                {ErrorCity ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText13 }]}> </Messages>
                                </div> : ''}
                            </div>
                            <div className="col-3 ml-2">
                                <Input event={{ onChange: this.handleChange }} id='cap' name='cap' type='text' dimension='lg'
                                    label='Post Code' value={this.infoStore.cap} inputClass={['mr-5']} labelClass={[]} extraProps={extraProps} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                                <div className="d-flex">
                                   
                                    <div className="col">
                                        <SelectInput id='statoAttivita' name='statoAttivita' value={this.infoStore.statoAttivita} dimension='lg' label='Country in which you have your business' firstEmptyOption={true} optionList={listaPlaceOfBusiness}
                                            inputClass={[]} labelClass={['requiredLabel']} event={{ onChange: this.handleChange }} extraProps={extraProps} error={error} />
                                    </div>
                                </div>
                                {ErrorStato ? <div className="col">
                                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageText14 }]}> </Messages>
                                </div> : ''}
                            </div>
                        </div>
                    </fieldset>

                    <fieldset id='contentFildset2'>
                        <legend className="contentlegend">Sole trader information</legend>
                        <div className="row">
                            <div className="col-2 ml-2">
                                <div className="d-flex">
                                    <Input id='firstName' name='firstName' type='text' dimension='lg' event={{ onChange: this.handleChange }}
                                        label='First name' value={firstName} inputClass={['mr-5']} labelClass={[]} extraProps={extraProps} />
                                </div>
                            </div>
                            <div className="col-2 ml-3">
                                <div className="d-flex">
                                    <Input id='lastName' name='lastName' type='text' dimension='lg' event={{ onChange: this.handleChange }}
                                        label='Last Name' value={lastName} inputClass={['mr-5']} labelClass={[]} extraProps={extraProps} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 ml-2">
                                <div className="d-flex" style={{ 'marginBottom': '-15px' }}>
                                    <DatePicker id="dateBirth" name="dateBirth" value={dateBirth} event={{ onChange: this.handleChangeData }} extraProps={extraProps} label="Date of birth"></DatePicker>
                                </div>
                            </div>
                            <div className="col-1 ml-3">
                                <SelectInput id='gender' name='gender' value={this.infoStore.gender} dimension='lg' label='Gender' firstEmptyOption={true} optionList={optionList} inputClass={[]} labelClass={[]} event={{ onChange: this.handleChange }} extraProps={extraProps} >
                                </SelectInput>
                            </div>
                        </div>
                        {ErrorDate_ ? <div className="col-2 mt-2">
                            <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageTextDate }]}> </Messages>
                        </div> : ''}
                        <div className="row mb-2">
                            <div className="col-3 ml-2">
                                <div className="d-flex" style={{ 'marginBottom': '-15px' }}>
                                    <SelectInput id='countryBirth' name='countryBirth' value={this.infoStore.countryBirth} dimension='lg' label='Country of Birth' firstEmptyOption={true} optionList={listaNascitaIndir} inputClass={[]} labelClass={[]} event={{ onChange: this.handleChange }} extraProps={extraProps} >
                                    </SelectInput>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset id='contentFildset3'>
                        <legend className="contentlegend">Contact information</legend>
                        <ContactInformation review={review} Information={Information} infoStore={this.infoStore} />
                    </fieldset>
                    <div className="row">
                        <div className="col-2" />
                        <div className="col-3" id="CaptchaID">
                            {(review && conferma) ? (<>

                                <Captcha></Captcha>

                                <button type="button" className="btn btn-primary mb-2 btnNew mt-4 ml-4 mr-3"
                                    onClick={() => this.handleModifica()} >Reset</button>

                                <button type="button" onClick={this.Conferma} className="btn btn-primary mb-2 mt-4 ml-4" data-toggle="modal" data-target="#containerId">
                                    Confirm
                                        </button>

                            </>) : (
                                <button type="button" className="btn btn-primary mb-2 btnNew mt-4 ml-4"
                                    onClick={() => this.submit()}>Submit</button>)}

                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            {ErrorMessageInvia ? <div className="col-6">
                                <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{ text: ErrorMessageTextInvia }]}> </Messages>
                            </div> : ''}
                        </div>

                    </div>
                </div>
                { this.infoStore.captchaLoaded === true ? <>{this.CaptchaLabel()}</> : ''}
            </section >
        );
    }


    handleChange = e => {
        const { name, value } = e.target;
        this.infoStore[name] = value;

        switch (name) {
            case "Email":
                this.infoStore.validateEmail(value)
                break;
            case "confermaEmail":
                this.infoStore.validateConfirmEmail(value)
                break;
            case "sitoWeb":
                this.infoStore.validateWebsite(value)
                break;
            case "denominazione":
                this.infoStore.validateCompany(value)
                break;
            case "descrizione":
                this.infoStore.validateDescription(value)
                break;
            case "sede":
                this.infoStore.validateAddress(value)
                break;
            case "citta":
                this.infoStore.validateCity(value)
                break;
            case "statoAttivita":
                this.infoStore.validateStato(value)
                break;
            default:

                break;
        }
        console.log('data', this.infoStore)
    }

    handleChangeData = value => {
        this.infoStore.dateBirth = value;
        if (!/^(3[01]|[12][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/[0-9]{4}$/.test(value)) {
            this.infoStore.ErrorMessageTextDate = 'wrong date';
            this.infoStore.ErrorDate_ = true;
        } else {
            this.infoStore.ErrorDate_ = false;
        }

    }


}

export default Iscrizione;